import { createFileRoute, useRouter } from "@tanstack/react-router";
import { useMenuItemStore } from "@/hooks/menuStore";

const MenuDetail = () => {
  const { item } = useMenuItemStore();
  const router = useRouter();
  if (!item) {
    router.history.replace("/menu/dining");
  }
  return (
    <div className="flex flex-col pb-16">
      <div className="w-screen pr-24 max-h-[829px] flex">
        <img src={item?.menu_image_url} className="pb-6 pr-4 w-full" />
        <span
          onClick={() => router.history.back()}
          className="text-xl cursor-pointer"
        >
          X
        </span>
      </div>

      <div>
        <span className="text-lg">{item?.menu_item_name} </span>
        <span className="text-sm font-sans">{item?.selling_price}</span>
      </div>
      <span className="text-sm font-sans">
        {item?.menu_item_description.toUpperCase()}
      </span>
    </div>
  );
};

export const Route = createFileRoute("/(menu)/menu/detail")({
  component: MenuDetail,
});
